module.exports = "https://r.nearpod.com/assets/media/image/collaborate-icon-f4202fe4ed961d54ee510f472b67008c.svg";